var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTabHomeNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72383 6.88837L7.58 2.03529C8.30811 1.43189 9.35933 1.42091 10.0999 2.00897L16.2437 6.88768C16.7215 7.26708 17 7.84382 17 8.45393V17.5C17 17.7761 16.7761 18 16.5 18H1.5C1.22386 18 1 17.7761 1 17.5V8.4283C1 7.83283 1.26534 7.26833 1.72383 6.88837Z",
    stroke: "#555555",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18L9 14",
    stroke: "#555555",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTabHomeNew);
export default __webpack_public_path__ + "static/media/ic_tab_home_new.a4715846df81e1ff161f7bfcfcd8314f.svg";
export { ForwardRef as ReactComponent };